import React, { useEffect, useRef, useMemo } from "react";
import { useTable, useRowSelect } from "react-table";
import { columnBaseTable } from "./tableHeaderTbc";
import { useDispatch } from "react-redux";
import { setSelectedFlatRows } from "../../../redux/actions/BookClosure/actionBookClosure";

import { formatAmount } from "../../../utils/formatAmount";
import tablecss from "../../../myfin_v2/css/table.module.css";
import commoncss from "../../../myfin_v2/css/common.module.css";

const TbcTableData = React.memo(({ lineItems, setDragData, searchText  }) => {
  const dispatch = useDispatch();
  const data = useMemo(() => lineItems, [lineItems]);
  const columns = useMemo(() => columnBaseTable, []);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    selectedFlatRows,
  } = useTable(
    {
      columns,
      data,
    },
    useRowSelect,
    (hooks) => {
      hooks.visibleColumns.push((columns) => [
        {
          id: "selection",
          Header: ({ getToggleAllRowsSelectedProps }) => (
            <div>
              <IndeterminateCheckbox {...getToggleAllRowsSelectedProps()} />
            </div>
          ),
          Cell: ({ row }) => (
            <div>
              <IndeterminateCheckbox {...row.getToggleRowSelectedProps()} />
            </div>
          ),
        },
        ...columns,
      ]);
    }
  );

  const selectedRowsMemo = useMemo(
    () => selectedFlatRows.map((row) => row.original),
    [selectedFlatRows]
  );

  useEffect(() => {
    dispatch(setSelectedFlatRows(selectedRowsMemo));
  }, [selectedRowsMemo, dispatch]);

  return (
    <>
      <div className={tablecss.tableContainer}>
        <table className={tablecss.customTable} {...getTableProps()}>
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column, i) => (
                  <th
                    key={column.id}
                    {...column.getHeaderProps()}
                    style={{
                      ...column.Style,
                      ...(i === 0
                        ? { width: "35px", minWidth: "35px", maxWidth: "35px" }
                        : {}),
                    }}
                    className={`font-inter ${
                      i === 0
                        ? "text-center"
                        : i === 3 || i === 4 || i === 5
                        ? "text-right pr-3"
                        : "text-left"
                    }`}
                  >
                    {column.render("Header")}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {rows.map((row, ind) => {
              prepareRow(row);
              if (
                row.original.deleted ||
                !row.original.ledgerCode.toLowerCase().includes(searchText.toLowerCase()) &&
                !row.original.ledgerName.toLowerCase().includes(searchText.toLowerCase()) &&
                !String(row.original.periodBeginingBalance).includes(searchText.toLowerCase()) &&
                !String(row.original.periodEndingBalance).includes(searchText.toLowerCase())
              ) return null;
              return (
                <tr
                  {...row.getRowProps()}
                  className={
                    row.original.deleted
                      ? "bg-danger"
                      : row.original?.FSGroupCY && row.original?.FSGroupPY
                      ? commoncss.doubleMapColor
                      : row.original?.FSGroupCY || row.original?.FSGroupPY
                      ? commoncss.singleMapColor
                      : ""
                  }
                  draggable
                  // onDragStart={(e) => {
                  //   setDragData(row.original);
                  // }}
                    // onDragStart={(e) => {
                    //   const rowsToDrag = selectedFlatRows.map((r) => r.original);
                    //   e.dataTransfer.setData("application/json", JSON.stringify(rowsToDrag));
                    //   setDragData(rowsToDrag);
                    // }}
                  onDragStart={(e) => {
                    // If some rows are selected, drag all selected rows
                    const rowsToDrag = selectedFlatRows.length > 0
                      ? selectedFlatRows.map(r => r.original)
                      : [row.original]; // otherwise drag just this row

                    e.dataTransfer.setData("application/json", JSON.stringify(rowsToDrag));
                    setDragData(rowsToDrag);
                  }}

                >
                  {row.cells.map((cell, i) => (
                    <td
                      style={{background:"transparent"}}
                      key={cell.column.id}
                      {...cell.getCellProps()}
                      className={`${
                        ["ledgerCode", "ledgerName"].includes(cell.column.id)
                          ? "text-left pl-3"
                          : "selection" === cell.column.id
                          ? "text-center"
                          : "text-right pr-3"
                      }`}
                    >
                      {[
                        "periodBeginingBalance",
                        "periodEndingBalance",
                      ].includes(cell.column.id)
                        ? formatAmount(cell.value)
                        : cell.render("Cell")}
                    </td>
                  ))}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </>
  );
});

export default TbcTableData;

const IndeterminateCheckbox = React.forwardRef(
  ({ indeterminate, ...rest }, ref) => {
    const defaultRef = useRef();
    const resolvedRef = ref || defaultRef;

    useEffect(() => {
      resolvedRef.current.indeterminate = indeterminate;
    }, [resolvedRef, indeterminate]);

    return <input type="checkbox" ref={resolvedRef} {...rest} />;
  }
);
